import React from "react";
import { useNavigate } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-b from-orange-200 to-gray-100 min-h-screen">
      {/* Hero Banner */}
      <div className="bg-blue-900 text-white py-16 px-4 md:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4 animate-fade-in">
            Privacy Policy
            <span className="block text-yellow-500 mt-2">
              Your Trust, Our Priority
            </span>
          </h1>
          <p className="text-lg md:text-xl max-w-2xl mx-auto mb-6">
            At Virtueista IT, we are committed to protecting your privacy and
            ensuring your data is handled responsibly.
          </p>
        </div>
      </div>

      {/* Policy Content */}
      <div className="max-w-4xl mx-auto px-4 py-12 md:py-16">
        <div className="space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              1. Introduction
            </h2>
            <p className="text-gray-600">
              Welcome to Virtueista IT, an IT training institute and software
              company based in Biratnagar, Nepal. This Privacy Policy outlines
              how we collect, use, disclose, and protect your personal
              information when you interact with our website, enroll in our
              courses, or use our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              2. Information We Collect
            </h2>
            <p className="text-gray-600">
              We may collect the following types of information:
            </p>
            <ul className="list-disc pl-5 text-gray-600">
              <li>
                <strong>Personal Information:</strong> Name, email address,
                phone number, and payment details when you register for courses
                or contact us.
              </li>
              <li>
                <strong>Usage Data:</strong> Information about how you interact
                with our website, such as IP address, browser type, and pages
                visited.
              </li>
              <li>
                <strong>Cookies:</strong> We use cookies to enhance your
                browsing experience and analyze website performance.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              3. How We Use Your Information
            </h2>
            <p className="text-gray-600">Your information is used to:</p>
            <ul className="list-disc pl-5 text-gray-600">
              <li>Process course registrations and payments.</li>
              <li>
                Send updates, newsletters, and promotional materials (with your
                consent).
              </li>
              <li>Improve our website and services through analytics.</li>
              <li>Respond to inquiries and provide customer support.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              4. Data Sharing and Disclosure
            </h2>
            <p className="text-gray-600">
              We do not sell or rent your personal information. We may share
              your data with:
            </p>
            <ul className="list-disc pl-5 text-gray-600">
              <li>
                Service providers (e.g., payment processors) to facilitate
                transactions.
              </li>
              <li>Legal authorities if required by law.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              5. Your Rights
            </h2>
            <p className="text-gray-600">You have the right to:</p>
            <ul className="list-disc pl-5 text-gray-600">
              <li>Access or update your personal information.</li>
              <li>Opt out of marketing communications.</li>
              <li>
                Request deletion of your data, subject to legal obligations.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              6. Contact Us
            </h2>
            <p className="text-gray-600">
              If you have questions about this Privacy Policy, please contact us
              at{" "}
              <a
                href="mailto:virtueistait@gmail.com"
                className="text-blue-600 hover:underline"
              >
                virtueistait@gmail.com
              </a>{" "}
              or call +977-9849489441.
            </p>
          </section>
        </div>
      </div>

      {/* Call to Action */}
      <div className="text-center bg-blue-800 text-white py-12 px-4">
        <h2 className="text-3xl font-bold mb-4">Have Questions?</h2>
        <p className="text-lg max-w-2xl mx-auto mb-6">
          Reach out to our team for any privacy-related inquiries.
        </p>
        <button
          onClick={() => navigate("/contact")}
          className="bg-yellow-500 text-blue-900 py-3 px-6 rounded-md font-semibold hover:bg-yellow-600 transition-all duration-300"
        >
          Contact Us
        </button>
      </div>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/9779849489441"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed right-4 top-1/2 transform -translate-y-1/2 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 hover:scale-110 transition-all duration-300 z-50"
        aria-label="Chat with us on WhatsApp"
      >
        <FaWhatsapp className="w-6 h-6 animate-spin-slow" />
      </a>

      {/* Inline CSS for Animations */}
      <style>
        {`
          @keyframes fade-in {
            0% { opacity: 0; transform: translateY(20px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          .animate-fade-in {
            animation: fade-in 1s ease-out;
          }
          @keyframes spin-slow {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .animate-spin-slow {
            animation: spin-slow 4s linear infinite;
          }
        `}
      </style>
    </div>
  );
};

export default PrivacyPolicy;
